import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'axisInput',
  props: {
  title: {
    type: String,
    default: '示例',
  },
  content: {
    type: String,
    default: '',
  },
},
  emits: ['update:content'],
  setup(__props, { emit }) {

const props = __props





function handleChangeValue(event: any) {
  emit('update:content', event.target.value)
}

return { __sfc: true,props, emit, handleChangeValue }
}

})